<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M9.71352 3.99986H6.28495L5.64351 2.07555C5.39683 1.33552 5.94766 0.571289 6.72772 0.571289H9.27074C10.0508 0.571289 10.6016 1.33552 10.355 2.07555L9.71352 3.99986Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.71401 4L10.8569 12.5714L7.99972 15.4286L5.14258 12.5714L6.28544 4"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
